<template>
  <div class="map-controls-left-wrapper left-column">
    <!--<div>
      <label for="vintage-pick">View Data as of</label>
      <select name="vintage-pick" id="">
        <option value="0">June, 30 2017</option>
      </select>
    </div>-->
    <div class="map-show-controls-Wrapper">
      <open-close-all
        :categories="categories">
      </open-close-all>
    </div>
  </div>
</template>

<script>
import OpenCloseAll from '../OpenCloseAll';

export default {
  name: 'map-contorls-left',
  props: ['categories'],
  components: {
    'open-close-all': OpenCloseAll,
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// MapControlsLeft.vue?4d2212e5